import Usuario from "model/administracao/cadastro/Usuario";
import EstagioOP from "./EstagioOP";

export default class ApontamentoOP {
    id: number;
    dataHoraApontamento: Date;
	tipo: string;
	usuario: Usuario;
    estagioOP: EstagioOP;
    qtProduzida: number;
    reprovado: boolean;

    constructor(
        id: number = 0,
        dataHoraApontamento: Date = new Date(),
        tipo: string = "",
        usuario: Usuario = new Usuario(),
        estagioOP: EstagioOP = new EstagioOP(),
        qtProduzida: number = 0,
        reprovado = false
    ) {
        this.id = id;
        this.dataHoraApontamento = dataHoraApontamento;
        this.tipo = tipo;
        this.usuario = usuario;
        this.estagioOP = estagioOP;
        this.qtProduzida = qtProduzida;
        this.reprovado = reprovado;
    }
}